import { usePopover, Overlay } from '@react-aria/overlays';
import React__default from 'react';
import { useSwanPopover } from './popover.context.js';
import { useInternalDialogConfigContext } from '../modal-dialog/dialog.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { ROOT_CLASSNAMES } from '../../../core/constants/globals.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propKeysToRemove = [
    'placement',
    'offset',
    'inModal',
    'isNonModal',
    'hideArrow',
    'fullBleed',
    'portalContainer',
    'labelText'
];
// should match the variable in the CSS
const DISTANCE_FROM_TRIGGER_PX = 8;
/**
 * Not a public component, has base functionality to be used by listbox, combobox, popover and menu
 *
 * @subcomponent Popover
 */ const PopoverContentInternal = renderWithRef('PopoverContent', {}, (props, ref)=>{
    const { children, offset = DISTANCE_FROM_TRIGGER_PX, isNonModal, portalContainer: portalContainerProp, hideArrow = false, fullBleed, className, placement = 'top' } = props;
    const { popoverRef, triggerRef, overlayProps, overlayState, hasDarkMode } = useSwanPopover();
    const { inModal, portalRef, dialogRef } = useInternalDialogConfigContext();
    const portalContainer = portalContainerProp !== null && portalContainerProp !== void 0 ? portalContainerProp : inModal && portalRef.current ? portalRef.current : undefined;
    const { popoverProps, underlayProps, placement: calculatedPlacement, arrowProps } = usePopover({
        popoverRef,
        triggerRef,
        placement,
        offset,
        isNonModal,
        // the popover will be absolutely positioned relative to the dialog element if it's in a modal
        boundaryElement: inModal && dialogRef.current || undefined
    }, overlayState);
    const combinedRef = assignRefs(ref, popoverRef);
    const classes = new Set([
        ROOT_CLASSNAMES.base,
        'swan-popover'
    ]) // the .swan class is needed for typography styling
    ;
    if (fullBleed) classes.add('swan-popover-skin-full-bleed');
    if (hasDarkMode) classes.add(ROOT_CLASSNAMES.darkMode);
    if (className) classes.add(className);
    return /*#__PURE__*/ React__default.createElement(Overlay, _object_spread_props(_object_spread({}, overlayProps), {
        portalContainer: portalContainer
    }), !isNonModal && /*#__PURE__*/ React__default.createElement("div", _object_spread_props(_object_spread({}, underlayProps), {
        className: "swan-popover-underlay"
    })), /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: combinedRef,
        props: _object_spread_props(_object_spread({}, props, popoverProps), {
            'aria-label': props.labelText,
            'data-placement': !hideArrow ? calculatedPlacement : undefined
        }),
        propKeysToRemove: propKeysToRemove,
        classNames: classes
    }, hideArrow ? null : /*#__PURE__*/ React__default.createElement("svg", _object_spread_props(_object_spread({}, arrowProps), {
        className: "swan-popover-arrow",
        viewBox: "0 0 24 24"
    }), /*#__PURE__*/ React__default.createElement("path", {
        d: "M0 0 L12 12 L24 0"
    })), children));
});

export { PopoverContentInternal };
